/**
 * Classes CSS que devem ser retornadas para
 * preencher as classes de componentes tags
 */

/**
 * Tag que indica se os campos de DAP/CAP e HT devem ser ou não obrigatórios
 */
const classesParaTagDeValidaCamposDAPeHT = {
	'Preenchimento Obrigatório': 'danger outlined',
	'Ausência Obrigatória': 'neutral outlined',
	Opcional: 'neutral',
}

/**
 * Tag que indica se a árvore é útil ou nao
 */
const classesParaTagDeArvoreUtil = {
	Útil: 'default',
	'Não Útil': 'neutral',
}

/**
 * Tag que indica os usuarios de aplicativos que estao bloqueados
 */
const classesParaUsuariosBloqueados = {
	Desbloqueado: 'default outlined',
	Bloqueado: 'danger outlined',
}

export {
	classesParaTagDeValidaCamposDAPeHT,
	classesParaTagDeArvoreUtil,
	classesParaUsuariosBloqueados,
}
